import {InjectionToken} from '@angular/core';

export const TISA_WICKET_URL = new InjectionToken<string | (() => string)>(
  'Provides base url of Wicket API.',
);

export const TISA_WICKET_DICTS_URL = new InjectionToken<string>(
  'Provides base url of Wicket Dictionaries API',
);

export const TISA_WICKET_V2_API_URL = new InjectionToken<string | (() => string)>(
  'Provides base url of Wicket V2 API',
);

export const TISA_WICKET_ENTITLEMENTS_API_URL = new InjectionToken<
  string | (() => string)
>('Provides base url of Wicket Entitlements API');

export const TISA_WICKET_TOKEN = new InjectionToken<string>(
  'Provides token for WICKET API authorization.',
);

export const WICKET_TOKEN_KEY = new InjectionToken<string>(
  'Provides key used to store token data in local storage',
);

export const WICKET_REFRESH_TOKEN_KEY = new InjectionToken<string>(
  'Provides key used to store encrypted refresh-token data in local storage',
);
